import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import RouteTitle from '../../../../presentation/RouteTitle';
import Alerts from '../../../../prototypes/Alerts';
import { clearUserProfile } from '../../../../redux/actions/user';
import { clearBugsnagUser } from '../../../../redux/actions/bugsnag';
import EtelAPI from '../../../../api/EtelAPI';
import Overlay from '../../../../presentation/Overlay';
import FileDetailsByDNISDialog from './FileDetailsByDNISDialog';

import * as wj from 'wijmo/wijmo.react.grid';
import * as wijmo from 'wijmo/wijmo';

// Wijmo Key
wijmo.setLicenseKey(
  'stage.etelconnections.com|172.16.0.116|dev.etelconnections.com|172.16.2.189|stage.eteconnections.com|172.16.1.15|www.etelconnections.com|172.16.0.112|lv.etelconnections.com|etelconnections.com|www.dev.etelconnections.com|172.16.1.22,854482378799655#B032Sbj9ycu3Wa4NWZu96bjxWZ4VmLldWY4NnI0IyctRkIsIybjVGblRVLFJiOiEmTDJCLiUTN6kTO7gzNzIDO4QTN8IiOiQWSiwSfdtlOicGbmJCLiIjdyIDMyIiOiIXZ6JCLlNHbhZmOiI7ckJye0ICbuFkI1pjIEJCLi4TPBh7RwYjWClUQRFnby9UMrYUcIJEZa5EevlTSzJHepVjdqxEZsl7QxhUS4t6UyFEdPNGbClWMQJHc7Z4Kv2EcG5kQwVzdMd4dIpHMrwWcz8ESONUW4wUQ7tCSBhmMIhzcykGTMpmTlNXMvpXRrd5Qo3ES7NUcPtSM9YHMMBVRJ36MtxUTxx6cBdlM64mUIZDMOdGWYhGZC3EcHdkRSZjZFBFUZ5GZX9ET8tSTMNVe5R7dzhlaYFUc5YVOadUe6ZjZWVDULt4RNBndYJ7U4NTbwckRItUUsF7c42Wc94WVEh7Y4JzRQRmMnJ5QrAnaThWdygVSqdkZaBFRrlHVP3UcrYENzRTOVR5bRJXQ6xka8ZnTqdlcitEcxtWZzhFSqZXaZJkeG3yKFZkSCpkR6QnexYjb43SWH9UbChXRykGTkxETn5UVrlzavIlR0lFNuNkbtZEdIJDSiojITJCLikTO6czN6IUNiojIIJCLwEjM6gDM4gTO0IicfJye35XX3JSSwIjUiojIDJCLi86bpNnblRHeFBCI4VWZoNFelxmRg2Wbql6ViojIOJyes4nI5kkTRJiOiMkIsIibvl6cuVGd8VEIgIXZ7VWaWRncvBXZSBybtpWaXJiOi8kI1xSfis4N8gkI0IyQiwiIu3Waz9WZ4hXRgAydvJVa4xWdNBybtpWaXJiOi8kI1xSfiQjR6QkI0IyQiwiIu3Waz9WZ4hXRgACUBx4TgAybtpWaXJiOi8kI1xSfiMzQwIkI0IyQiwiIlJ7bDBybtpWaXJiOi8kI1xSfiUFO7EkI0IyQiwiIu3Waz9WZ4hXRgACdyFGaDxWYpNmbh9WaGBybtpWaXJiOi8kI1tlOiQmcQJCLiAzMwEDOwAyNxgDMzIDMyIiOiQncDJCLiIjMuEjL6EjLycTMs46bj9ycu3Wa4NWZu96bjxWZ4VmL6VGZuc7d7xSbvNmLz96bpR7Yl9mbvNGblRXZs46bj9ycu3Wa4NWZu96bjxWZ4VmL6xGLyETMuAjL6EjLycTMs46bj9ycu3Wa4NWZu96bjxWZ4VmL7d7dsUTMuEjL6EjLycTMs46bj9ycu3Wa4NWZu96bjVGdl9SZnFGdzxSO8EjLy8iNx8iM7EDLt36YuMnbvlGdjVmbu36YsVGdl9idlRGL6ETMuAjL6EjLtcYM'
);

class ByDNIS extends Component {
  constructor( props ) {
    super( props );

    this.state = {
      userFilter: 0,
      dnisFilter: '',
      destinationFilter: '',
      programNameFilter: '',
      filenameFilter: '',
      usedAsFilter: '',
      users: [],
      files: [{ DESTINATION: 'Loading' }],
      doubleClickedRow: {},
      showFileDetailsDialog: false
    };

    // Bindable events
    this.onHandleChange = this.onHandleChange.bind( this );
    this.onHandleClickSearch = this.onHandleClickSearch.bind( this );
    this.onHandleClickClear = this.onHandleClickClear.bind( this );
    this.onHandleDoubleClickGrid = this.onHandleDoubleClickGrid.bind( this );
    this.onHandleCloseDialogs = this.onHandleCloseDialogs.bind( this );

    // Exception handling
    this.onHandleException = this.onHandleException.bind( this );

    // Properties / fields
    this.wijmoGrid = React.createRef();
    this.wijmoPanel = null;
  }

  /****************************************************************************
   * STATE / LIFECYCLE METHODS
   ***************************************************************************/

  componentDidMount() {
    this.alerts = new Alerts( this.props.bugsnag, this.props.dispatch );

    Promise.all( [
      this.getUsers(),
      this.fileUploadSearch()
    ] ).then( ( [userResults, fileResults] ) => {
      this.setState( {
        users: userResults,
        files: fileResults
      } );
    } ).catch( ( exception ) => {
      this.onHandleChange( exception );
    } );
  }

  /****************************************************************************
   * API CALLS
   ***************************************************************************/

  /**
   * Retrieves distinct users who are actively using/has file uploads.
   */
  getUsers() {
    return new Promise( ( resolve, reject ) => {
      const api = new EtelAPI( 'filemanagement/byfilename/users' );

      api.get( [] ).then( ( results ) => {
        resolve( results );
      } ).catch( ( exception ) => {
        reject( exception );
      } );
    } );
  }

  /**
   * Retrieves the files by DNIS.
   *
   * @param {Array<Object>} params Parameters to pass to the endpoint.
   */
  fileUploadSearch( params ) {
    return new Promise( ( resolve, reject ) => {
      const api = new EtelAPI( 'filemanagement/byfilename/fileuploadsearch' );

      if ( api !== undefined ) {
        api.get( params ).then( ( results ) => {
          resolve( results );
        } ).catch( ( exception ) => {
          reject( exception );
        } );
      }
    } );
  }

  /****************************************************************************
   * EXCEPTION HANDLING
   ***************************************************************************/

  /**
   * Returns user back to the login page if creds fail.
   */
  doLogOff() {
    const { dispatch, auth, history } = this.props;

    auth.logout();
    dispatch( clearBugsnagUser() );
    dispatch( clearUserProfile() );
    history.push( '/login' );
  }

  /**
   * Handles exceptions.
   *
   * @param {Error} e The exception thrown.
   */
  onHandleException( e ) {
    const title = 'File Management';
    const status = e.status === undefined ? 0 : e.status;

    if ( status === 410 ) {
      this.alerts.INFO( title, 'Your session has expired.', 5000 );
      this.doLogOff();
    } else if ( status === 500 ) {
      this.alerts.INFO( title, e.statusText, 5000 );
      this.doLogOff();
    } else if ( status === 400 ) {
      this.alerts.WARNING( title, 'Request timed out.', 5000 );
    } else {
      this.alerts.CRITICAL( title, e );
    }
  }

  /****************************************************************************
   * EVENT HANDLING
   ***************************************************************************/

  /**
   * Handles the change events for all filter inputs.
   *
   * @param {Event} event Change event for a specific input.
   */
  onHandleChange( event ) {
    this.setState( {
      [event.target.name]: event.target.value
    } );
  }

  /**
   * Handles the click event for the Search button.
   *
   * @param {Event} event Click event for the Search button.
   */
  onHandleClickSearch( event ) {
    if ( event.key !== 'Enter' && event.target.value !== 'Search' ) {
      return;
    }

    const params = [
      { DNIS: this.state.dnisFilter },
      { PROGRAM_NAME: this.state.programNameFilter },
      { FILENAME: this.state.filenameFilter },
      { UPLOAD_TYPE: this.state.usedAsFilter },
      { DESTINATION: this.state.destinationFilter },
      { REACT_USER_ID: this.state.userFilter }
    ];

    this.setState( {
      files: [{ DESTINATION: 'Loading' }]
    } );

    this.fileUploadSearch( params ).then( ( fileResults ) => {
      this.setState( {
        files: fileResults
      } );
    } ).catch( ( exception ) => {
      this.onHandleException( exception );
    } );
  }

  /**
   * Handles the click event for the Clear button.
   *
   * @param {Event} event Click event for the Clear button.
   */
  onHandleClickClear( event ) {
    this.setState( {
      userFilter: 0,
      dnisFilter: '',
      destinationFilter: '',
      programNameFilter: '',
      filenameFilter: '',
      usedAsFilter: '',
      files: [{ DESTINATION: 'Loading' }]
    }, () => {
      this.fileUploadSearch( [] ).then( ( results ) => {
        this.setState( {
          files: results
        } );
      } );
    } );
  }

  /**
   * Handles the double click event on a wijmo grid row.
   *
   * @param {Event} event Double click of the wijmo grid.
   */
  onHandleDoubleClickGrid( event ) {
    const doubleClickedRow = this.wijmoPanel.control.selectedItems[0];

    this.setState( {
      showFileDetailsDialog: true,
      doubleClickedRow: doubleClickedRow
    } );
  }

  /**
   * Handles the closing of any dialog. Also refreshes the main grid for any
   * updates.
   *
   * @param {Event} event Closing of any dialog.
   * @param {Boolean} shouldRefresh Should the main page refresh from changes.
   */
  onHandleCloseDialogs( event, shouldRefresh ) {
    this.setState( {
      showFileDetailsDialog: false
    } );

    if ( shouldRefresh ) {
      this.setState( {
        files: [{ DESTINATION: 'Loading' }]
      }, () => {
        const params = [
          { DNIS: this.state.dnisFilter },
          { PROGRAM_NAME: this.state.programNameFilter },
          { FILENAME: this.state.filenameFilter },
          { UPLOAD_TYPE: this.state.usedAsFilter },
          { DESTINATION: this.state.destinationFilter },
          { REACT_USER_ID: this.state.userFilter }
        ];

        this.fileUploadSearch( params ).then( ( results ) => {
          this.setState( {
            files: results
          } );
        } ).catch( ( exception ) => {
          this.onHandleException( exception );
        } );
      } );
    }
  }

  /****************************************************************************
   * RENDERS
   ***************************************************************************/
  renderFilters() {
    const userOptions = this.state.users.map( ( user ) => {
      return <option key={user.REACT_USER_ID} value={user.REACT_USER_ID}>{user.NAME}</option>;
    } );

    return (
      <span className='list-filter'>
        <span className='list-filter-controls'>
          <span className='list-filter-control'>
            <label className='list-filter-label'>User</label>
            <select className='list-filter-dropdown' name='userFilter' onChange={this.onHandleChange} value={this.state.userFilter}>
              <option value='0'></option>
              {userOptions}
            </select>
          </span>
          <span className='list-filter-control'>
            <label className='list-filter-label'>DNIS</label>
            <input className='list-filter-textbox' type='text' name='dnisFilter' onChange={this.onHandleChange} onKeyDown={this.onHandleClickSearch} value={this.state.dnisFilter} />
          </span>
          <span className='list-filter-control'>
            <label className='list-filter-label'>Name</label>
            <input className='list-filter-textbox' type='text' name='programNameFilter' onChange={this.onHandleChange} onKeyDown={this.onHandleClickSearch} value={this.state.programNameFilter} />
          </span>
          <span className='list-filter-control'>
            <label className='list-filter-label'>Filename</label>
            <input className='list-filter-textbox' type='text' name='filenameFilter' onChange={this.onHandleChange} onKeyDown={this.onHandleClickSearch} value={this.state.filenameFilter} />
          </span>
          <span className='list-filter-control'>
            <label className='list-filter-label'>Destination</label>
            <select className='list-filter-dropdown' name='destinationFilter' onChange={this.onHandleChange} value={this.state.destinationFilter}>
              <option value=''></option>
              <option value='1'>LEADGEN</option>
              <option value='2'>PROGRAM</option>
            </select>
          </span>
          <span className='list-filter-control'>
            <label className='list-filter-label'>Used as</label>
            <select className='list-filter-dropdown' name='usedAsFilter' onChange={this.onHandleChange} value={this.state.usedAsFilter}>
              <option value=''></option>
              <option value='0'>TFN</option>
              <option value='1'>OFF NET</option>
              <option value='2'>ON NET</option>
            </select>
          </span>
        </span>
        <span className='list-filter-search'>
          <button className='list-filter-search-button' value='Search' onClick={this.onHandleClickSearch}>Search</button>
          <button className='list-filter-clear-button' value='Clear' onClick={this.onHandleClickClear}>Clear</button>
        </span>
      </span>
    );
  }

  renderByDNISGrid() {
    return (
      <div
        className='file-management-by-dnis-wijmo-container'
        ref={this.wijmoGrid}
        style={{ width: '100%' }}
        onDoubleClick={this.onHandleDoubleClickGrid}
      >
        <wj.FlexGrid
          ref={( panel ) => {
            this.wijmoPanel = panel; 
          }}
          selectionMode='Row'
          style={{ border: 'none', overflow: 'auto' }}
          itemsSource={this.state.files}
        >
          <wj.FlexGridColumn width='*' header='Destination' binding='DESTINATION' isContentHtml={true} isReadOnly={true} align='center' />
          <wj.FlexGridColumn width='*' header='DNIS' binding='DEFDNIS' isContentHtml={true} isReadOnly={true} align='center' />
          <wj.FlexGridColumn width='2*' header='Name' binding='NAME' isContentHtml={true} isReadOnly={true} align='center' />
          <wj.FlexGridColumn width='*' header='Program Type' binding='PROGRAM_TYPE' isContentHtml={true} isReadOnly={true} align='center' />
          <wj.FlexGridColumn width='*' header='PDNIS' binding='PDNIS' isContentHtml={true} isReadOnly={true} align='center' />
          <wj.FlexGridColumn width='*' header='Program Name' binding='PROGRAM_NAME' isContentHtml={true} isReadOnly={true} align='center' />
          <wj.FlexGridColumn width='.5*' header='Type' binding='TYPE' isContentHtml={true} isReadOnly={true} align='center' />
          <wj.FlexGridColumn width='2*' header='Filename' binding='FILENAME' isContentHtml={true} isReadOnly={true} align='center' />
          <wj.FlexGridColumn width='2*' header='Description' binding='DESCRIPTION' isContentHtml={true} isReadOnly={true} align='center' />
          <wj.FlexGridColumn width='.5*' header='Dups' binding='COUNT_DUPS' isContentHtml={true} isReadOnly={true} align='center' />
          <wj.FlexGridColumn width='.75*' header='Errors' binding='COUNT_ERROR' isContentHtml={true} isReadOnly={true} align='center' />
          <wj.FlexGridColumn width='*' header='Processed' binding='PROCESSED' isContentHtml={true} isReadOnly={true} align='center' />
          <wj.FlexGridColumn width='*' header='Processed On' binding='PROCESSED_ON' isContentHtml={true} isReadOnly={true} align='center' />
          <wj.FlexGridColumn width='*' header='Username' binding='USER_NAME' isContentHtml={true} isReadOnly={true} align='center' />
        </wj.FlexGrid>
      </div>
    );
  }

  render() {
    const showOverlay = this.state.showFileDetailsDialog;

    return (
      <div className='file-management-by-dnis-grid-container'>
        <RouteTitle title={'File Management by DNIS'} />
        {this.renderFilters()}
        {this.renderByDNISGrid()}
        <Overlay show={showOverlay} />
        <FileDetailsByDNISDialog
          show={this.state.showFileDetailsDialog}
          onClose={this.onHandleCloseDialogs}
          filedata={this.state.doubleClickedRow}
        />
      </div>
    );
  }
}

export default withRouter(
  connect(
    ( store ) => {
      return {
        auth: store.auth.auth,
        bugsnag: store.bugsnag.Bugsnag,
        user: store.user.user
      };
    }
  )( ByDNIS )
);



// WEBPACK FOOTER //
// ./src/content/enterprise/filemanagement/components/ByDNIS.js